import React, { useContext } from 'react';
import { Navigate } from 'react-router';
import { AuthContext } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
    const { token } = useContext(AuthContext);

    return token ? children : <Navigate to="/" />;
};

export default PrivateRoute;
